export default {
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 'inherit',
    height: 'inherit',
    ':hover': {
      opacity: 0.2,
    },
  },
  upload: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'block',
    margin: 'auto',
    borderRadius: 30,
    backgroundColor: 'white',
  },
  fileInput: {
    display: 'none',
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/ImageUpload/styles.js